import { hasRole } from "@morawadigital/skynet-framework"

export const isAdmin = user => hasRole( user, 'admin' ) // TODO Remove hardcoded value

export const isScheduler = user => hasRole( user, 'einteiler' ) // TODO Remove hardcoded value

export const isSchedulerWithoutRelease = user => hasRole( user, 'einteiler ohne freigabe' ) // TODO Remove hardcoded value